document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- READ MORE BUTTON CODE (unchanged) ---------------- */
  const btn = document.getElementById('read-more-btn');
  if (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      const tabNav = document.querySelector('.Tab_Nav');
      if (!tabNav) return;
      const container = tabNav.closest('.gf_restabs') || tabNav;
      let hiddenAncestor = null;
      for (let el = container; el; el = el.parentElement) {
        const style = window.getComputedStyle(el);
        if (style.display === 'none') { hiddenAncestor = el; break; }
        if (el.tagName === 'BODY') break;
      }
      if (hiddenAncestor) hiddenAncestor.style.display = 'block';
      let headerHeight = 0;
      const header = document.querySelector('header.sticky, .sticky, .site-header');
      if (header) headerHeight = header.getBoundingClientRect().height;
      requestAnimationFrame(() => {
        const rect = container.getBoundingClientRect();
        const absoluteY = rect.top + window.pageYOffset - headerHeight - 10;
        window.scrollTo({
          top: Math.max(0, Math.floor(absoluteY)),
          behavior: 'smooth'
        });
      });
    });
  }

});


document.addEventListener("DOMContentLoaded", function () {
    const viewport = document.querySelector(".yy-festive-viewport");
    const track = document.querySelector(".yy-festive-track");
    const items = document.querySelectorAll(".yy-festive-item");

    if (!viewport || !track || !items.length) {
        return;
    }

    let index = 0;
    let itemHeight = 0;
    let started = false;

    function measureHeightAndStart() {
        const rect = items[0].getBoundingClientRect();

        // If height is zero, layout is not ready yet
        if (rect.height === 0) {
            requestAnimationFrame(measureHeightAndStart);
            return;
        }

        itemHeight = rect.height;
        viewport.style.height = itemHeight + "px";
        track.style.transform = "translateY(" + (-index * itemHeight) + "px";

        if (!started) {
            started = true;
            rollNext();
        }
    }

    function rollNext() {
        const current = items[index];
        const interval = parseInt(current.dataset.interval, 10) || 5000;

        setTimeout(function () {
            index = (index + 1) % items.length;
            track.style.transform = "translateY(" + (-index * itemHeight) + "px";
            rollNext();
        }, interval);
    }

    // Measure once layout is real
    measureHeightAndStart();

    // Keep it responsive on resize
    window.addEventListener("resize", function () {
        const rect = items[0].getBoundingClientRect();
        if (rect.height > 0) {
            itemHeight = rect.height;
            viewport.style.height = itemHeight + "px";
            track.style.transform = "translateY(" + (-index * itemHeight) + "px";
        }
    });
});


document.addEventListener('DOMContentLoaded', async function () {
  const invoiceBtn = document.querySelector('.invoice-btn');
  const productForm = document.querySelector('form[action="/cart/add"]');
  const purchaseTypeInput = document.getElementById('purchase-type');

  if (!invoiceBtn || !productForm || !purchaseTypeInput) return;

  invoiceBtn.addEventListener('click', async function (e) {
    e.preventDefault();

    // ✅ Mark as Invoice purchase
    purchaseTypeInput.value = 'Invoice';

    const success = await addToCartCustom(productForm);

    if (success) {
      if (purchaseTypeInput) purchaseTypeInput.value = "";
      window.location.href = "/pages/cart-new";
    } else {
      console.error("Add to cart failed.");
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const isInvoice = params.get('invoice') === 'true';
  if (!isInvoice) return;

  // Observe DOM changes (dynamic buttons)
  const observer = new MutationObserver(() => {
    const checkoutBtn = document.querySelector(
      'button[name="checkout"], .cart-submit-button, a[href*="/checkout"]'
    );
    if (checkoutBtn) {
      checkoutBtn.textContent = 'Proceed To Checkout with invoice';
      // Stop observing once changed
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Optional: clean URL so ?invoice=true disappears
  window.history.replaceState({}, '', '/cart');
});


document.addEventListener("DOMContentLoaded", function() {

  const standard = document.getElementById("type-standard");
  const executive = document.getElementById("type-executive");
  const selectedValue = document.querySelector(".custom-type-switch .selected-value");

  if (!selectedValue) return;

  // Set initial value
  if (standard && standard.checked) {
    selectedValue.textContent = "STANDARD";
  }

  if (executive && executive.checked) {
    selectedValue.textContent = "EXECUTIVE";
  }

  if (standard) {
    standard.addEventListener("change", function() {
      if (this.checked) {
        selectedValue.textContent = "STANDARD";
        window.location.href = "/products/veneto-task-chair";
      }
    });
  }

  if (executive) {
    executive.addEventListener("change", function() {
      if (this.checked) {
        selectedValue.textContent = "EXECUTIVE";
        window.location.href = "/products/veneto-executive-task-chair";
      }
    });
  }

});


document.addEventListener("DOMContentLoaded", function () {

  const seatInputs = document.querySelectorAll('input[name="Seat Colour"]');
  const baseInputs = document.querySelectorAll('input[name="Base & Column"]');

  const regularLabel = document.querySelector(
    '.all-variant[data-name="Height"] label[title="Regular : for users under 165cm (5’5”)"]'
  );

  const regularInput = document.querySelector(
    '.all-variant[data-name="Height"] input[value="Regular : for users under 165cm (5’5”)"]'
  );

  function checkCondition() {
    const selectedSeat = document.querySelector('input[name="Seat Colour"]:checked')?.value;
    const selectedBase = document.querySelector('input[name="Base & Column"]:checked')?.value;

    if (selectedSeat === "Black" && selectedBase === "White") {
      // Enable Regular
      if(regularLabel){
        regularLabel.style.pointerEvents = "auto";
        regularLabel.style.opacity = "1";
      }
      if(regularInput){
        regularInput.disabled = false;
      }
    } else {
      // Disable Regular
      if(regularLabel){
        regularLabel.style.pointerEvents = "none";
        regularLabel.style.opacity = ".2";
      }
      if(regularInput){
        regularInput.disabled = true;
      }
    }
  }

  checkCondition();

  seatInputs.forEach(input => input.addEventListener("change", checkCondition));
  baseInputs.forEach(input => input.addEventListener("change", checkCondition));

});


document.addEventListener("DOMContentLoaded", function () {

  const standardValue = "STANDARD (51-84cm)";
  const extendedValue = "Extended Height (60-93cm):  [extra £ 30]";

  const standardRadio = document.querySelector('input[name="Height Adjustment"][value="' + standardValue + '"]');
  const extendedRadio = document.querySelector('input[name="Height Adjustment"][value="' + extendedValue + '"]');

  const standardLabel = standardRadio ? document.querySelector('label[for="' + standardRadio.id + '"]') : null;
  const extendedLabel = extendedRadio ? document.querySelector('label[for="' + extendedRadio.id + '"]') : null;

  const seatRadios = document.querySelectorAll('input[name="Seat Colour"]');

  function disableOption(radio, label) {
    radio.disabled = true;
    label.style.pointerEvents = "none";
    label.style.opacity = "0.2";
  }

  function enableOption(radio, label) {
    radio.disabled = false;
    label.style.pointerEvents = "";
    label.style.opacity = "";
  }

  function handleSeatChange() {
    const selectedSeat = document.querySelector('input[name="Seat Colour"]:checked');
    if (!selectedSeat) return;

    if (selectedSeat.value === "Black") {

      // Select STANDARD
      standardRadio.checked = true;
      standardRadio.dispatchEvent(new Event('change', { bubbles: true }));

      // Disable EXTENDED
      disableOption(extendedRadio, extendedLabel);
      enableOption(standardRadio, standardLabel);

    } else if (selectedSeat.value === "Grey") {

      // Select EXTENDED
      extendedRadio.checked = true;
      extendedRadio.dispatchEvent(new Event('change', { bubbles: true }));

      // Disable STANDARD
      disableOption(standardRadio, standardLabel);
      enableOption(extendedRadio, extendedLabel);

    } else {

      // For other colors (Green, Blue, Red)
      enableOption(standardRadio, standardLabel);
      enableOption(extendedRadio, extendedLabel);

    }
  }

  // Run on load
  handleSeatChange();

  // Run on seat change
  seatRadios.forEach(radio => {
    radio.addEventListener("change", handleSeatChange);
  });

});



document.addEventListener("DOMContentLoaded", function () {

  const fabricTypeRadios = document.querySelectorAll('input[name="Fabric Type"]');
  const fabricColourRadios = document.querySelectorAll('input[name="Fabric Colours"]');

  function filterColours(selectedType) {

    let keyword = "";

    if (selectedType.includes("CARA")) {
      keyword = "CARA";
    } else if (selectedType.includes("X2")) {
      keyword = "X2";
    }

    fabricColourRadios.forEach(function (radio) {

      const label = document.querySelector('label[for="' + radio.id + '"]');
      if (!label) return;

      if (radio.value.includes(keyword)) {
        radio.style.display = "";
        label.style.display = "";
      } else {
        radio.style.display = "none";
        label.style.display = "none";
        radio.checked = false;
      }

    });

    // Select first visible option
    const firstVisible = Array.from(fabricColourRadios).find(radio =>
      radio.style.display !== "none"
    );

    if (firstVisible) {
      firstVisible.checked = true;

      const selectedValueText = document.querySelector(
        '.all-variant[data-name="Fabric Colours"] .selected-value'
      );

      if (selectedValueText) {
        selectedValueText.textContent = firstVisible.value;
      }
    }
  }

  fabricTypeRadios.forEach(function (radio) {
    radio.addEventListener("change", function () {
      filterColours(this.value);
    });
  });

  // Run on page load
  const defaultSelected = document.querySelector('input[name="Fabric Type"]:checked');
  if (defaultSelected) {
    filterColours(defaultSelected.value);
  }

});





/* =========================================================================
   MAIN ADD-TO-CART BLOCK
   ---------------------------------------------------------------------
   FIX APPLIED HERE (2024): _accessoryGroupId used to be read straight out
   of the hidden #form_accessories_container input at click time. That
   input is only refreshed by updateAccessoryCardData() on option-change
   events, NOT on every Add to Cart click. So if you clicked Add to Cart
   twice without changing any option in between (e.g. same desk added
   again), both requests reused the SAME stale group id, and the two
   resulting bundles' accessories got cross-linked/merged in the cart
   drawer and cart page.

   Fix: mint + verify a brand-new group id right here, at the moment of
   submission, every single time — instead of trusting whatever is
   currently sitting in the hidden field. Also added a re-entrancy guard
   so a fast double-click can't fire two overlapping adds.

   Nothing about the UI, the hidden field name, or any other file changes
   because of this — cart-drawer.js / cart-new.js / the liquid templates
   all still just read properties._accessoryGroupId exactly as before.

   FIX APPLIED HERE (2025): the delivery-option validation used to run
   unconditionally on every product page, checking for
   `.delivery-card.selected`. Products like installation-service-5 and
   care-10-year-install-warranty don't render any `.delivery-card`
   elements at all, so `selectedDelivery` was always null and Add to Cart
   was incorrectly blocked (or behaved inconsistently depending on other
   markup on the page).

   Fix: first check whether `.delivery-card` elements exist on the page
   at all via `document.querySelectorAll(".delivery-card")`. The
   validation block (and the early `return false`) now only runs when
   there's at least one delivery card present. Pages with no delivery
   cards skip the check entirely and proceed straight to the rest of
   addToCartCustom, exactly as before this fix for products that DO have
   delivery cards.
========================================================================= */
document.addEventListener('DOMContentLoaded', async function() {

  let isUpdatingDrawer = false;
  let isAddingToCart = false; // NEW: guards against double-click re-entrancy

  // NEW: local helpers — scoped to this file only, nothing else needs to change
  async function generateUniqueAccessoryGroupIdLocal() {
    const generate = () => Math.floor(10000000000 + Math.random() * 90000000000).toString();

    let newId;
    let exists = true;

    do {
      newId = generate();
      exists = await validateAccessoryGroupIdLocal(newId);
    } while (exists);

    return newId;
  }

  async function validateAccessoryGroupIdLocal(id) {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    return cart.items.some((item) => {
      return String(item.properties?._accessoryGroupId) === String(id);
    });
  }

  document.addEventListener("click", async function (e) {
    const addToCartBtn = e.target.closest("#geo-add-to-cart");
    if (!addToCartBtn) return;

    // Prevent the native form submission triggered by this click
    e.preventDefault();

    // NEW: block a second click while the first add is still in flight
    if (isAddingToCart) return;
    isAddingToCart = true;

    let originalText = null;
    const span = addToCartBtn.querySelector('span');
    if (span) {
      originalText = span.textContent;
      span.textContent = "Adding...";
    }

    const pageLoader = document.getElementById('page_Loader');
    if(pageLoader){
      pageLoader.classList.add('open');
    }

    const productForm = addToCartBtn.closest('form.js-product-form.form[action="/cart/add"]');
    if (!productForm) {
      isAddingToCart = false; // NEW: release lock on early return
      return;
    }

    const success = await addToCartCustom(productForm);

    if (success) {
      setTimeout(openCartDrawer, 1000);
    } else {
      console.error("Add to cart failed.");
    }

    if(originalText){
      span.textContent = originalText;
    }
    setTimeout(()=>{
      if(pageLoader){
        pageLoader.classList.remove('open');
      }
      isAddingToCart = false; // NEW: release the lock
    }, 1000);
  }, true);


  async function addToCartCustom(productForm) {

    // Require a delivery option — but only on pages that actually have
    // delivery cards. Products like installation-service-5 and
    // care-10-year-install-warranty have none, so they skip this check.
    const deliveryCards = document.querySelectorAll(".delivery-card");

    if (deliveryCards.length > 0) {
      const selectedDelivery = document.querySelector(".delivery-card.selected");

      if (!selectedDelivery) {

        const error = document.querySelector(".delivery-validation-error");

        if (error) {
          error.hidden = false;
        }

        document.querySelector(".delivery-options-wrapper")?.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

        return false;
      }
    }

    let productQuantity = 1;
    const formAccessoryContainer = productForm.querySelector('#form_accessories_container');
    const productQuantityInput = document.querySelector('input.quantity__input[id*="Quantity-template"]');
    if(productQuantityInput) {
      productQuantity = productQuantityInput.value;
    }

    let accessoryVariantIds = [];
    let accessoryVariantNames = [];
    let accessoryGroupId = null;

    if (formAccessoryContainer) {
      const variantIdsInput = formAccessoryContainer.querySelector('input[name="properties[_accessoryVariantIds]"]');
      const accessoryGroupInput = formAccessoryContainer.querySelector('input[name="properties[_accessoryGroupId]"]');

      if (variantIdsInput && variantIdsInput.value) {

        // ✅ FIX: always mint + verify a fresh group id for THIS click,
        // instead of trusting whatever value is currently sitting in the
        // hidden input (which may be stale from an earlier add-to-cart
        // click or an earlier option selection).
        accessoryGroupId = await generateUniqueAccessoryGroupIdLocal();
        if (accessoryGroupInput) {
          accessoryGroupInput.value = accessoryGroupId;
        }

        const variantIds = variantIdsInput.value;

        accessoryVariantIds = variantIds
          .split(",")
          .map(id => id.trim())
          .filter(Boolean);

        const namesInput = formAccessoryContainer.querySelector('input[name="properties[_accessoryVariantNames]"]');
        accessoryVariantNames = (namesInput?.value || "").split(",").map(s => s.trim());
      }
    }

    // NOTE: formData is built AFTER the group id is (re)written above, so
    // it always snapshots the freshly-generated id, not a stale one.
    const formData = new FormData(productForm);

    try {
      // 1) Add main product first (unchanged)
      const mainRes = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
        headers: { "Accept": "application/json" },
      });

      if (!mainRes.ok) {
        const text = await mainRes.text().catch(() => "");
        console.error("Main product add failed:", mainRes.status, mainRes.statusText, text);
        return false;
      }

        // 2) Add all accessories in a single /cart/add.js call
      if (accessoryVariantIds.length > 0) {
                const accessoriesPayload = {
          items: accessoryVariantIds.map(id => {
            const item = {
              id,
              quantity: productQuantity,
            };

            if (accessoryGroupId) {
              item.properties = {
                _accessoryGroupId: accessoryGroupId,
              };
            }

            // If this accessory is a bundle, attach its contents so the
            // warehouse sees them directly under the bundle line
            const bundleCard = document.querySelector(
              '.accessory-card.is-bundle-card.active[data-variant-id="' + id + '"]'
            );
            if (bundleCard) {
              const contents = Array.from(
                bundleCard.querySelectorAll(".accessory-details-info li")
              )
                .map(li => li.textContent.replace(/\s+/g, " ").trim())
                .filter(Boolean)
                .join(" | ");

              if (contents) {
                item.properties = item.properties || {};
                item.properties["Includes"] = contents;
              }
            }

            return item;
          }),
        };

        const accessoriesRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
          },
          body: JSON.stringify(accessoriesPayload),
        });

        if (!accessoriesRes.ok) {
          const text = await accessoriesRes.text().catch(() => "");
          console.error(
            "Accessories add failed:",
            accessoriesRes.status,
            accessoriesRes.statusText,
            text
          );
          return false;
        }
      }

      // ✅ NEW: defensive cleanup — blank the hidden field after a
      // successful add so nothing can accidentally reuse this id again,
      // even if some other code path calls addToCartCustom directly
      // without going through the click handler above.
      if (formAccessoryContainer) {
        const accessoryGroupInput = formAccessoryContainer.querySelector('input[name="properties[_accessoryGroupId]"]');
        if (accessoryGroupInput) {
          accessoryGroupInput.value = "";
        }
      }

      return true;

    } catch (err) {
      console.error("Add to cart encountered a network error:", err);
      return false;
    }
  }
  window.addToCartCustom = addToCartCustom;

});

document.addEventListener("DOMContentLoaded", async function () {

  document.addEventListener("click", async function (e) {
    const invoiceBtn = e.target.closest(".invoice-btn");
    if (!invoiceBtn) return;

    e.preventDefault();

    const purchaseTypeInput = document.getElementById("purchase-type");
    if (purchaseTypeInput) purchaseTypeInput.value = "Invoice";

    const productForm = document.querySelector('form[action="/cart/add"]');
    if (!productForm) return;

    const success = await addToCartCustom(productForm);

    if (success) {
      if (purchaseTypeInput) purchaseTypeInput.value = "";
      setTimeout(openCartDrawer, 1200);
    } else {
      console.error("Add to cart failed.");
    }
  });

});


// custom top  bespoke button js
document.addEventListener('click', function(e){

    if(!e.target.closest('#bespoke-options-btn')) return;

    const accessoriesSection = document.querySelector('#dynamic-accessories-section');

    if(accessoriesSection){
        const yOffset = -125; // adjust if needed
        const y = accessoriesSection.getBoundingClientRect().top + window.pageYOffset + yOffset;

        window.scrollTo({
            top: y,
            behavior: 'smooth'
        });
    }

    setTimeout(function(){

        const customTab = document.querySelector(
            '.accessory-tab[data-tab="custom_top_options"]'
        );

        if(customTab){
            customTab.click();
        }

    }, 600);

});
document.addEventListener('DOMContentLoaded', function () {

  function clampQuantityInput(input) {
    if (!input) return;
    const min = parseInt(input.getAttribute('min'), 10) || 1;
    const maxAttr = input.getAttribute('max');
    const max = maxAttr ? parseInt(maxAttr, 10) : null;

    let val = parseInt(input.value, 10);
    if (isNaN(val) || val < min) val = min;
    if (max !== null && val > max) val = max;

    if (String(val) !== input.value) {
      input.value = val;
    }
  }

  function lockQuantityInput(input) {
    if (!input || input.dataset.qtyLocked) return;
    input.dataset.qtyLocked = '1';

    input.setAttribute('readonly', 'readonly');
    input.setAttribute('inputmode', 'none');
    if (!input.getAttribute('min')) input.setAttribute('min', '1');

    // Manual typing / paste / scroll-wheel are all disabled — quantity can
    // only change via the +/- buttons.
    input.addEventListener('keydown', function (e) { e.preventDefault(); });
    input.addEventListener('paste', function (e) { e.preventDefault(); });
    input.addEventListener('wheel', function () { input.blur(); });

    // Clamp on ANY change, including whatever the theme's own quantity-input
    // web component does internally on button click — this is what stops
    // it going to 0 / negative when clicking minus repeatedly.
    input.addEventListener('input', function () { clampQuantityInput(input); });
    input.addEventListener('change', function () { clampQuantityInput(input); });
  }

  // Lock every quantity input present now...
  document.querySelectorAll('.quantity__input').forEach(lockQuantityInput);

  // ...and re-clamp immediately after every +/- click, after the theme's
  // own handler has run, since that's the path that was producing -4.
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quantity__button');
    if (!btn) return;
    const wrapper = btn.closest('quantity-input') || btn.closest('.product-form__quantity');
    const input = wrapper ? wrapper.querySelector('.quantity__input') : null;
    if (!input) return;
    requestAnimationFrame(function () { clampQuantityInput(input); });
  }, true);

  // Catch quantity inputs added later (variant re-renders, AJAX swaps).
  const qtyObserver = new MutationObserver(function () {
    document.querySelectorAll('.quantity__input').forEach(lockQuantityInput);
  });
  qtyObserver.observe(document.body, { childList: true, subtree: true });

});

// new price total based on qtyButtons

document.addEventListener('DOMContentLoaded', function () {

  const qtyInput = document.querySelector('.quantity__input');
  if (!qtyInput) return;

  function currentQuantity() {
    const q = parseInt(qtyInput.value, 10);
    return isNaN(q) || q < 1 ? 1 : q;
  }

  function parseMoney(text) {
    if (!text) return null;
    let cleaned = text.replace(/[^\d.,]/g, '').trim();
    if (cleaned.indexOf('.') === -1 && cleaned.indexOf(',') !== -1) {
      cleaned = cleaned.replace(',', '.');
    } else {
      cleaned = cleaned.replace(/,/g, '');
    }
    const val = parseFloat(cleaned);
    return isNaN(val) ? null : val;
  }

  function makeSelfHealingWriter(selector) {
    let el = null;
    let currencyPrefix = '';
    let currencySuffix = '';

    function captureCurrencyFormat(text) {
      const match = text.trim().match(/^([^\d]*)([\d.,\s]+)([^\d]*)$/);
      if (match) {
        currencyPrefix = match[1];
        currencySuffix = match[3];
      }
    }

    function formatMoney(value) {
      const withThousands = value.toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return currencyPrefix + withThousands + currencySuffix;
    }

    function bindTo(newEl) {
      el = newEl;
      captureCurrencyFormat(el.textContent);
    }

    const initialEl = document.querySelector(selector);
    if (initialEl) bindTo(initialEl);

    return {
      write: function (value) {
        // Self-heal: re-find the element in case a variant swap replaced it
        const current = document.querySelector(selector);
        if (!current) return;
        if (current !== el) bindTo(current);
        const target = el.querySelector('.money') || el;
        target.textContent = formatMoney(value);
      },
    };
  }

function makeQuantityPriceWatcher(selector) {
    let el = null;
    let unitPrice = null;
    let isProgrammaticUpdate = false;
    let currencyPrefix = '';
    let currencySuffix = '';
    let observer = null;
    const onChangeCallbacks = [];

    function captureCurrencyFormat(text) {
      const match = text.trim().match(/^([^\d]*)([\d.,\s]+)([^\d]*)$/);
      if (match) {
        currencyPrefix = match[1];
        currencySuffix = match[3];
      }
    }

    function formatMoney(value) {
      const withThousands = value.toLocaleString('en-GB', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return currencyPrefix + withThousands + currencySuffix;
    }

    function applyQuantity() {
      if (!el || unitPrice === null) return;
      // const total = unitPrice * currentQuantity();
      const qty = currentQuantity();
            const ex = pdpLimitedAccessoryExtra(qty);
      const total = (unitPrice - ex.unit) * qty + ex.actual;
      pdpLog(
        'price [' + selector + ']',
        '| unit shown:', unitPrice,
        '| limited unit/actual:', ex.unit, ex.actual,
        '| qty:', qty,
        '| NEW total:', total
      );
      isProgrammaticUpdate = true;
      const target = el.querySelector('.money') || el;
      target.textContent = formatMoney(total);
      requestAnimationFrame(function () { isProgrammaticUpdate = false; });
      onChangeCallbacks.forEach(function (cb) { cb(unitPrice, total); });
    }

    function bindTo(newEl) {
      if (observer) observer.disconnect();
      el = newEl;
      isProgrammaticUpdate = false;

      captureCurrencyFormat(el.textContent);
      unitPrice = parseMoney(el.textContent);

      observer = new MutationObserver(function () {
        if (isProgrammaticUpdate) return;
        const parsed = parseMoney(el.textContent);
        if (parsed !== null) {
          unitPrice = parsed;
          applyQuantity();
        }
      });
      observer.observe(el, { childList: true, subtree: true, characterData: true });

      applyQuantity();
    }

    const initialEl = document.querySelector(selector);
    if (initialEl) bindTo(initialEl);

    return {
      applyQuantity: applyQuantity,
      onChange: function (cb) { onChangeCallbacks.push(cb); },
      healIfNeeded: function () {
        const current = document.querySelector(selector);
        if (!current) return;
        if (current !== el || !el.isConnected) {
          bindTo(current);
        }
      },
    };
  }

  // --- Inc VAT: the source of truth, watched for real mutations --------
  const incVatBottom = makeQuantityPriceWatcher('.price.inc-vat.totalprice.gf_product-price');
  const incVatTop = makeQuantityPriceWatcher('#main-price-incl-vat');

  // --- Exc VAT: NOT independently watched — accessory/delivery scripts
  // write it to an element that doesn't exist on this page (.additional-prices
  // .ex-vat-wrapper .money), so waiting for a mutation on the real element
  // never fires. Instead, derive it directly from Inc VAT ÷ 1.2, matching
  // the same formula price-section-new.liquid uses server-side.
  const excVatWriter = makeSelfHealingWriter('.price.ex-vat.totalprice_1.money');

  function syncExcVatFromIncVat(unitPrice, total) {
    excVatWriter.write(total / 1.2);
  }
  incVatTop.onChange(syncExcVatFromIncVat);

  const watchers = [incVatBottom, incVatTop];

  function applyQuantityToAll() {
    watchers.forEach(function (w) { w.applyQuantity(); });
  }

  qtyInput.addEventListener('input', applyQuantityToAll);
  qtyInput.addEventListener('change', applyQuantityToAll);

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.quantity__button')) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(applyQuantityToAll);
    });
  });

  let healTimer = null;
  const healObserver = new MutationObserver(function () {
    clearTimeout(healTimer);
    healTimer = setTimeout(function () {
      watchers.forEach(function (w) { w.healIfNeeded(); });
    }, 50);
  });
  healObserver.observe(document.body, { childList: true, subtree: true });

});


document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes("/products/ongo-classic")) return;

  const blackValue = "Black";
  const tallValue = "Tall : for users 170cm (5’6”) and over [extra £24]";

  function applySeatColourLock() {
    const seatInputs = document.querySelectorAll('input[name="Seat Colour"]');
    if (!seatInputs.length) return;

    const blackInput = Array.from(seatInputs).find(
      input => input.value.trim() === blackValue
    );

    if (!blackInput) return;

    if (!blackInput.checked) {
      blackInput.checked = true;
      blackInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    seatInputs.forEach(function (input) {
      const label = document.querySelector('label[for="' + input.id + '"]');
      const isBlack = input === blackInput;

      input.disabled = !isBlack;

      if (label) {
        label.style.pointerEvents = isBlack ? "auto" : "none";
        label.style.opacity = isBlack ? "1" : "0.2";
      }
    });

    const selectedValue = document.querySelector(
      '.all-variant[data-name="Seat Colour"] .selected-value'
    );

    if (selectedValue) {
      selectedValue.textContent = blackInput.value;
    }
  }

  function applyHeightLock() {
    const heightInputs = document.querySelectorAll('input[name="Height"]');
    if (!heightInputs.length) return;

    const tallInput = Array.from(heightInputs).find(
      input => input.value.trim() === tallValue
    );

    if (!tallInput) return;

    if (!tallInput.checked) {
      tallInput.checked = true;
      tallInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    heightInputs.forEach(function (input) {
      const label = document.querySelector('label[for="' + input.id + '"]');
      const isTall = input === tallInput;

      input.disabled = !isTall;

      if (label) {
        label.style.pointerEvents = isTall ? "auto" : "none";
        label.style.opacity = isTall ? "1" : "0.2";
      }
    });

    const selectedValue = document.querySelector(
      '.all-variant[data-name="Height"] .selected-value'
    );

    if (selectedValue) {
      selectedValue.textContent = tallInput.value;
    }
  }

  setTimeout(function () {
    applySeatColourLock();
    applyHeightLock();
  }, 300);

  document.addEventListener("change", function (e) {
    if (e.target.matches('input[name="Seat Colour"]')) {
      if (e.target.value.trim() !== blackValue) {
        setTimeout(applySeatColourLock, 0);
      } else {
        applySeatColourLock();
      }
    }

    if (e.target.matches('input[name="Height"]')) {
      if (e.target.value.trim() !== tallValue) {
        setTimeout(applyHeightLock, 0);
      } else {
        applyHeightLock();
      }
    }
  });
});
const PDP_DEBUG = true; // set to false to silence all logs

function pdpLog(...args) {
  if (PDP_DEBUG) console.log('[pdp-limit]', ...args);
}

const PDP_LIMITED_VARIANT_IDS = [
  57642286350723,
  57642264199555,
  58097161994627,
  58097162027395,
  58006245278083,
  57642286317955,
  58315118510467,
  57897585672579,
  57897585705347,
  57897585738115,
  62695256850819,
  62695256883587,
  62695256916355,
  62683693547907,
  62306697642371,
  62306798502275,
  62306794963331,
  62448224502147,
  62448224534915,
  62448224567683,
  58097161961859, // FREE Delivery (4 week lead time)
];

function pdpIsLimitedVariant(id) {
  return PDP_LIMITED_VARIANT_IDS.includes(Number(id));
}

const PDP_LIMITED_PARENT_PRODUCT_IDS = [
  7011044720738,
  6964149387362,
  6893008224354,
  7051912773730,
  7011126018146,
  7052130156642,
  7011029581922,
];

function pdpIsLimitedParentProduct(productId) {
  return PDP_LIMITED_PARENT_PRODUCT_IDS.includes(Number(productId));
}

function pdpIsDeliveryName(name) {
  const n = (name || '').toLowerCase();
  return n.includes('delivery') || n.includes('installation') ||
         (n.includes('order value') && n.includes('15000'));
}

// function pdpGetAccessoryQuantity(parentProductId, parentQty, variantId, isDelivery) {
//   parentQty = parseInt(parentQty, 10) || 1;

//   if (pdpIsLimitedParentProduct(parentProductId)) {
//     // if (pdpIsLimitedVariant(variantId) || isDelivery) return parentQty > 3 ? 2 : 1;
//     if (pdpIsLimitedVariant(variantId) || isDelivery) return Math.ceil(parentQty / 3);
//     return parentQty;
//   }

//   if (pdpIsLimitedVariant(variantId)) return 1;
//   return parentQty;
// }


function pdpGetAccessoryQuantity(parentProductId, parentQty, variantId, isDelivery) {

parentQty = parseInt(parentQty, 10) || 1;

if (pdpIsLimitedParentProduct(parentProductId)) {
if (pdpIsLimitedVariant(variantId) || isDelivery) {
  return Math.ceil(parentQty / 3);
}
return parentQty;
}

if (pdpIsLimitedVariant(variantId)) return 1;

return parentQty;
}



// Returns { unit, actual } in pounds for accessories that do NOT follow parent qty.
function pdpLimitedAccessoryExtra(parentQty) {
  const container = document.querySelector('#form_accessories_container');
  if (!container) return { unit: 0, actual: 0 };

  const idsInput    = container.querySelector('input[name="properties[_accessoryVariantIds]"]');
  const pricesInput = container.querySelector('input[name="properties[_accessoryVariantPrices]"]');
  const namesInput  = container.querySelector('input[name="properties[_accessoryVariantNames]"]');
  if (!idsInput || !idsInput.value || !pricesInput) return { unit: 0, actual: 0 };

  const ids      = idsInput.value.split(',').map(s => s.trim());
  const prices   = pricesInput.value.split(',').map(s => parseFloat(s.trim()));
  const names    = (namesInput?.value || '').split(',');
  const parentId = Number(document.querySelector('input[name="product-id"]')?.value || 0);

  let unit = 0, actual = 0;
  ids.forEach((id, i) => {
    if (isNaN(prices[i])) return;
    const q = pdpGetAccessoryQuantity(parentId, parentQty, id, pdpIsDeliveryName(names[i]));
    // pdpLog('extra: id', id, '| qty rule:', q, '| price:', prices[i]);
    if (q !== parentQty) {
      unit   += prices[i];
      actual += prices[i] * q;
    }
  });

  return { unit: unit / 100, actual: actual / 100 };
}

// 120x70 or 160x80, the Natural Timber hide js 

(function () {
  var BLOCKED_COLOUR = 'Natural Timber';
  var BLOCKED_SIZES  = ['120x70', '160x80','120x70cm', '160x80cm'];

  function update() {
    // Handle every product form on the page
    document.querySelectorAll('input[name="Desk Top Size(cm)"]:checked').forEach(function (sizeInput) {
      var form   = sizeInput.closest('form') || document;
      var blocked = BLOCKED_SIZES.indexOf(sizeInput.value) !== -1;

      form.querySelectorAll('input[name="Desk Top Colour"]').forEach(function (colourInput) {
        if (colourInput.value !== BLOCKED_COLOUR) return;
        var label = document.querySelector('label[for="' + colourInput.id + '"]');
        if (label) label.classList.toggle('swatch-blocked', blocked);
        colourInput.disabled = blocked;

        // If Natural Timber is already selected, switch to the first allowed colour
        if (blocked && colourInput.checked) {
          var next = Array.from(form.querySelectorAll('input[name="Desk Top Colour"]'))
            .find(function (i) { return i.value !== BLOCKED_COLOUR && !i.disabled; });
          if (next) next.click();
        }
      });
    });
  }

  document.addEventListener('change', function () { setTimeout(update, 50); });
  document.addEventListener('DOMContentLoaded', update);
  window.addEventListener('load', update);

  // Re-apply if the theme re-renders the swatches
  new MutationObserver(function () { update(); })
    .observe(document.body, { childList: true, subtree: true });
})();